<div class="px-20">
<div class=" justify-center product-details w-full shadow-sm" *ngFor="let review of reviews" >
    <img
    [src]="customerCommentImageUrl + review.product.images[0]"
    [alt]="review.product.productDetails.name"
    class="product-image"
    />
    <h2>{{ review.product?.productDetails?.productName }}</h2>
  <p>{{ review.product.productDetails.productDescription }}</p>
  <p><strong>Price:</strong> ₹{{ review.product.priceInventoryShippingInfo.sellingPrice }}</p>
</div>

<hr />

<div *ngIf="loading">Loading reviews...</div>

<div *ngIf="!loading && reviews.length === 0">
  <p>No reviews yet.</p>
</div>

<div *ngIf="!loading && reviews.length > 0" class="reviews-section">
  <h3>Customer Reviews</h3>

  <div *ngFor="let review of reviews" class="review-card">
    <div class="review-user">
      <img
        [src]="customerCommentImageUrl + review.images || 'assets/default-avatar.png'"
        [alt]="review.user?.name"
        width="50"
        height="50"
        class="user-avatar"
      />
      <div class="user-info">
        <span class="user-name">{{ review.user?.name || 'Anonymous' }}</span>
        <div class="flex rating">
          <!-- <ng-container *ngFor="let star of [1,2,3,4,5]">
            <span [class.filled]="star <= review?.rating">⭐</span>
          </ng-container> -->
           <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
            <svg
              class="h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              [ngClass]="{
                'text-yellow-500': star <= review?.rating,
                'text-gray-300': star > review?.rating
              }"
            >
              <path
                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
              ></path>
            </svg>
          </ng-container>
           <span class="text-sm ml-1 text-blue-500 font-bold">
            {{ review.rating.legnth }} Ratings & Reviews
          </span>
        </div>
      </div>
    </div>

    <p class="review-text">"{{ review.reviewText }}"</p>
  </div>
</div>
</div>